/**
 * DCMS FRONTEND API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import {ValidatorFn, Validators} from "@angular/forms";

export interface DiagnosisPermissions { 
    add: boolean;
    change: boolean;
    destroy: boolean;
}
export const DiagnosisPermissions_add_Validators: ValidatorFn[] =
    [  Validators.required, ];

export const DiagnosisPermissions_change_Validators: ValidatorFn[] =
    [  Validators.required, ];

export const DiagnosisPermissions_destroy_Validators: ValidatorFn[] =
    [  Validators.required, ];


